export const callbackWrapper = (callback) => ({ params: { payload } }) => callback(payload);
